import React from "react";
import { ArrowrightupSVG, ArrowrightdownSVG, ArrowrightSVG } from "src/assets/svg";

const arrowTypes = (type) => {
  switch (type) {
    case "up":
      return <ArrowrightupSVG />;
    case "down":
      return <ArrowrightdownSVG />;
    default:
      return <ArrowrightSVG />;
  }
};

const descriptionClass = (type) => {
  switch (type) {
    case "up":
      return "text-port-green";
    case "down":
      return "text-port-red";
    default:
      return "text-port-yellow";
  }
};

const PortfolioContent = (props) => {
  const { title, amount, description, returns } = props;
  return (
    <div className="bg-white rounded-lg">
      <div className="text-lg text-light-gray mb-2 font-bold">{title}</div>
      <div className="text-2xl font-bold text-light-black">{amount}</div>
      <div className="flex items-center justify-end text-sm text-red-500 mt-2">
        {arrowTypes(returns)}
        <div className={`${descriptionClass(returns)} font-bold`}>{description}</div>
      </div>
    </div>
  );
};

export default PortfolioContent;
